
import {i18nPages} from "@/i18n.config.js";

export default {
  name: "SupportOverviewItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
      i18nPages,
    };
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
};
